export default __webpack_public_path__ + "static/media/1-Sevan-Hvordan definerer du din identitet.5766c75f.mp4";